"use strict";

var React = require('react/addons');
var Fluxxor = require('fluxxor');
var _ = require('underscore');

var LanguageStore = Fluxxor.createStore({
  actions: {
    ACCEPT_LANGUAGE_WARNING: 'onAcceptLanguageWarning',
    SET_LANGUAGE: 'onSetLanguage'
  },

  initialize: function(options) {
    this.setMaxListeners(0);
    this.state = _.clone(options);
  },

  onAcceptLanguageWarning: function() {
    this.state = React.addons.update(this.state, {
      acceptedWarning : {$set: true}
    });
    document.cookie = 'accepted_language_warning=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
    this.emit('change');
  },

  onSetLanguage: function(payload) {
    document.cookie = 'language=en; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
    window.location.reload();
  },

  getState: function () {
    return this.state;
  }

});

module.exports = LanguageStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/stores/language.js
 **/